import { render, staticRenderFns } from "./CustomFieldsCreateLayoutModal.vue?vue&type=template&id=1b9a42c2&"
import script from "./CustomFieldsCreateLayoutModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsCreateLayoutModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports